/* eslint @typescript-eslint/camelcase: "off" */

import { API_URL, UPLOAD_URL, getConfig } from '@constants';

import { getParametrizedUrl } from '@common/utils';

import { BaseApi } from '../BaseApi';

import {
	IDmcaApiUploadFileRequestParams,
	IDmcaApiUploadFileResponseData,
	IDmcaApiSubmitRequestParams,
	IDmcaApiSubmitResponseData,
} from './types';

export class DmcaApi extends BaseApi {

	async uploadFile(file: File) {
		return this.put<IDmcaApiUploadFileRequestParams, IDmcaApiUploadFileResponseData>({
			url: `${getConfig().hosts.upload}${getParametrizedUrl(UPLOAD_URL.DMCA_UPLOAD_FILE, { name: file.name })}`,
			data: file,
			isNoProcessData: true,
		});
	}

	async submit(params: IDmcaApiSubmitRequestParams) {
		return this.post<IDmcaApiSubmitRequestParams, IDmcaApiSubmitResponseData>({
			url: API_URL.DMCA_SUBMIT,
			data: params,
		}, {
			arrayFormat: 'enumeration',
		});
	}

}
